exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drawer-wrapper[data-v-4be455b2] .el-drawer .el-drawer__header {\n  font-size: 0.09375rem;\n  font-weight: bold;\n}", ""]);

// exports
